import { Container, Form, Row, Col } from 'react-bootstrap';
import { Address } from '../FormFields/Address';
import { ControlButtons } from '../ControlButtons';
import { useForm } from 'react-hook-form';
import { blastingSiteSchema } from '../../schemas/blastingSiteSchema';
import { yupResolver } from '@hookform/resolvers/yup';
import { PhoneNumber } from '../FormFields/PhoneNumber';

export const BlastingSite = ({
	blastingSite = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const { register, handleSubmit, formState } = useForm({
		resolver: yupResolver(blastingSiteSchema),
		defaultValues: blastingSite,
	});
	return (
		<Container className="component mb-3">
			<Container className="component mt-5">
				<h1>Blasting Site Information</h1>
				<Address register={register} error={formState.errors} />
				<Row>
					<Form.Group as={Col} xs={12} md={6}>
						<Form.Label>Business Name</Form.Label>
						<Form.Control type="text" {...register('businessName')} />
						<Form.Text className="text-danger">
							{formState.errors.businessName?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group as={Col} xs={12} md={6}>
						<Form.Label>Name of Project</Form.Label>
						<Form.Control type="text" {...register('projectName')} />
						<Form.Text className="text-danger">
							{formState.errors.projectName?.message}
						</Form.Text>
					</Form.Group>
				</Row>
				<Row>
					<Form.Group as={Col} xs={12} md={6}>
						<Form.Label>Emergency Contact</Form.Label>
						<Form.Control type="text" {...register('contactName')} />
						<Form.Text className="text-danger">
							{formState.errors.contactName?.message}
						</Form.Text>
					</Form.Group>
					<Form.Group as={Col} xs={12} md={6}>
						<Form.Label>Phone Number</Form.Label>
						<PhoneNumber register={register} />
						<Form.Text className="text-danger">
							{formState.errors.phone?.message}
						</Form.Text>
					</Form.Group>
				</Row>
			</Container>
			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={onSubmit}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}
			/>
		</Container>
	);
};
